<template>
  <nav class="navbar" :class="{ 'fixed-element': isFixed }">
    <div class="navbar-container">
      <div class="logo">
        <NuxtLink
          :to="localPath('/')"
          aria-label="Página de inicio de Tradeview Europe"
        >
          <picture>
            <source
              media="(max-width: 1440px)"
              srcset="/images/logo-main-mobile.svg"
              width="44"
              height="28"
            />
            <source
              media="(min-width: 1441px)"
              srcset="/images/logo-main.svg"
              width="300"
              height="46"
            />
            <img src="/images/logo-main.svg" alt="" width="300" height="46" />
          </picture>
        </NuxtLink>
      </div>
      <div class="options" id="options">
        <ul>
          <li v-for="(item, index) in navItems" :key="index" class="itemMenu">
            <template v-if="!item.subpages">
              <NuxtLink
                :to="localPath(item.link)"
                class="nav-link"
                @click="closeMenu"
              >
                {{ $t(item.text) }}
              </NuxtLink>
            </template>
            <template v-else>
              <span
                @click.prevent="handleItemClick(item, $event)"
                class="menu-link"
              >
                {{ $t(item.text) }}
                <span
                  v-if="item.subpages"
                  class="material-symbols-outlined"
                  translate="no"
                  :class="{
                    'arrow-rotate': insNavbarOpen && itemSelected === item.text,
                  }"
                >
                  expand_more
                </span>
              </span>
            </template>
          </li>
        </ul>
      </div>
      <div class="opt">
      </div>
      <div class="btns">
        <LazyLanguagesModal />
        <a :href="getExternalUrl('/login')" target="_blank" rel="noopener noreferrer">
          <button class="second-button-small body-4-bold">
            {{ $t("menu.singIn") }}
          </button>
        </a>
        <a target="_blank" :href="getExternalUrl('/register/1/live-account')" rel="noopener noreferrer">
          <button class="primary-button-small body-4-bold">
            {{ $t("menu.getStarted") }}
          </button>
        </a>
      </div>
    </div>
    <transition name="fade">
      <div
        class="subpages"
        ref="submenuContent"
        v-show="insNavbarOpen"
        id="subpages"
        @mouseleave="closeMenu"
      >
        <div class="content-mayor">
          <div class="content-items" ref="contentItems">
            <div
              v-for="(item, i) in navItems"
              :key="i"
              :class="item.class"
              class="group-items"
            >
              <div v-for="(sub, j) in item.subpages" :key="j">
                <div v-if="itemSelected === item.text">
                  <p>
                    <NuxtLink
                      class="nav-link"
                      :class="sub.class ? sub.class : ''"
                      :to="localPath(sub.link)"
                      :target="sub.target"
                      @click="insNavbarOpen = false"
                    >
                      {{ $t(sub.text) }}
                    </NuxtLink>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import LazyLanguagesModal from "@/components/defaultLayout/LanguagesModal.vue";
// import '~/assets/scss/components/navbar.scss';
import { useExternalUrl } from "@/composables/useExternalUrl";
import { useI18n } from "vue-i18n";
const { getExternalUrl } = useExternalUrl();
const { locale } = useI18n();

const localPath = useLocalePath();
const isFixed = ref(false);
const insNavbarOpen = ref(false);
const itemSelected = ref("");
const submenuContent = ref(null);
const contentItems = ref(null);
const navItems = computed(() => [
  {
    text: "menu.trading",
    class: "trading",
    subpages: [
      {
        text: "menu.markets",
        link: "/trading/markets",
        class: "body-4-bold",
      },
      {
        text: "menu.forex",
        link: "/trading/markets/forex",
        class: "body-4",
      },
      {
        text: "menu.stocks",
        link: "/trading/markets/stocks",
        class: "body-4",
      },
      /* {
        text: "menu.futures",
        link: "/trading/markets/futures",
        class: "body-4",
      }, */
      {
        text: "menu.commodities",
        link: "/trading/markets/commodities",
        class: "body-4",
      },
      {
        text: "menu.indices",
        link: "/trading/markets/indices",
        class: "body-4",
      },
      {
        text: "menu.platforms",
        link: "/trading/platforms",
        class: "body-4-bold",
      },
      /* {
        text: "menu.mt4",
        link: "/trading/platforms/metatrader4",
        class: "body-4",
      }, */
      {
        text: "menu.mt5",
        link: "/trading/platforms/metatrader5",
        class: "body-4",
      },
      /* {
        text: "menu.ctrader",
        link: "/trading/platforms/ctrader",
        class: "body-4",
      },
      {
        text: "menu.takion",
        link: "/trading/platforms/takion",
        class: "body-4",
      },
      {
        text: "menu.lightspeed",
        link: "/trading/platforms/lightspeed",
        class: "body-4",
      },
      {
        text: "menu.sterling2",
        link: "/trading/platforms/sterling-trader",
        class: "body-4",
      },
      {
        text: "menu.DAS",
        link: "/trading/platforms/das-trader",
        class: "body-4",
      },
      {
        text: "menu.cqg",
        link: "/trading/platforms/cqg-desktop",
        class: "body-4",
      }, */
      {
        text: "menu.yourTrading",
        link: "/trading",
        class: "body-4-bold",
      },
      // {
      //   text: "menu.challenge",
      //   link: "/trading/gold-challenge",
      //   class: "body-4",
      // },
       {
        text: "menu.calculator-suite",
        link: "/trading/calculator_suite",
        class: "body-4",
      }, 
      {
        text: "menu.economic-calendar",
        link: "/trading/markets/trading-conditions/forex-economic-calendar/",
        class: "body-4",
      },
      {
        text: "menu.trading-eventos",
        link: "/trading/markets/trading-conditions/trading-conditions-events/",
        class: "body-4",
      },
      {
        text: "menu.accounts",
        link: "/trading/accounts",
        class: "body-4-bold",
      },
    ],
  },
  /* {
    text: "menu.partners",
    class: "partners",
    subpages: [
      {
        text: "menu.introducing",
        link: "/partners",
        class: "body-4-bold",
      },
      {
        text: "menu.influence",
        link: "/partners/influence-affiliates",
        class: "body-4",
      },
    ],
  }, */
  {
    text: "menu.company",
    class: "company",
    subpages: [
      {
        text: "menu.aboutUs",
        link: "/company/about-us",
        class: "body-4",
      },
      /* {
        text: "menu.press",
        link: "/company/press-and-media",
        class: "body-4",
      }, */
      /* {
        text: "menu.careers",
        link: "/company/careers",
        class: "body-4",
      }, */
      {
        text: "menu.authorized",
        link: "/company/regulation",
        class: "body-4",
      },
      /* ...(locale.value === "en"
        ? [
            {
              text: "menu.factsPolicy",
              link: "/company/facts-policy",
              class: "body-4",
              target: "_blank",
            },
          ]
        : []), */
    ],
  },
  /* {
    text: "menu.services",
    class: "services",
    subpages: [
      {
        text: "menu.services",
        link: "/services",
        class: "body-4-bold",
      },
      {
        text: "menu.communiTraders",
        link: "/services/communitraders",
        class: "body-4",
      },
      {
        text: "menu.tradeGATEHub",
        link: "/services/tradegatehub-surfs-up",
        class: "body-4",
      },
      {
        text: "menu.vulkanBridge",
        link: "/services/vulkan-bridge",
        class: "body-4",
      },
      {
        text: "menu.MultiMAA",
        link: "/services/multimam",
        class: "body-4",
      },
      {
        text: "menu.ctradercopy",
        link: "/trading/platforms/ctrader-copy",
        class: "body-4",
      },
    ],
  }, */
  {
    text: "menu.formsDocuments",
    link: "/forms-and-documents",
  },
  {
    text: "menu.faq",
    link: "/faq",
  },
  {
    text: "menu.contactUs",
    link: "/contact-us",  
    
  },
]);
const openMenu = (menuText, event) => {
  const menuItem = event.currentTarget;

  if (insNavbarOpen.value && itemSelected.value === menuText) {
    insNavbarOpen.value = false;
    itemSelected.value = "";
  } else {
    insNavbarOpen.value = true;
    itemSelected.value = menuText;

    // Calcula la posición `left` del ítem seleccionado
    const menuLeftPosition = menuItem.getBoundingClientRect().left;

    // Aplica la posición al contenedor `content-items` en el siguiente frame
    if (contentItems.value) {
      requestAnimationFrame(() => {
        contentItems.value.style.left = `${menuLeftPosition}px`;
      });
    }
  }
};

const closeMenu = () => {
  insNavbarOpen.value = false;
  itemSelected.value = "";
};

const handleItemClick = (item, event) => {
  if (item.subpages) {
    openMenu(item.text, event);
  } else {
    closeMenu();
  }
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const handleScroll = () => {
  const alturaUmbral = 50;
  let scrollY = window.scrollY;

  isFixed.value = scrollY >= alturaUmbral;
};
</script>
